export { SlideTextSizeSlider } from "#slide-text-size-slider";
